module.exports = __webpack_public_path__ + "img/app_main_bt1.ee8808d3.png";